export default __webpack_public_path__ + "static/media/plus_calendar.9b0603b8.svg";